export enum EMENInvoicePrintForm {
  MARKING_5 = 'Marking5',
  INTERNATIONAL_MARKING = 'International_Marking'
}

export enum EMENInvoiceState {
  IEW = 'IEW',
  CLOSED = 'Closed',
  REQUEST = 'Request',
  UPDATED = 'Updated',
  VERIFIED = 'Verified',
  NOT_VERIFIED = 'NotVerified',
}

export const INVOICE_STATE_MAP: Record<EMENInvoiceState, { status: string, statusComment: string }> = {
  [EMENInvoiceState.IEW]: { status: 'Відправлено', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EMENInvoiceState.CLOSED]: { status: 'Отримано', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EMENInvoiceState.REQUEST]: { status: 'Заявка', statusComment: 'Очікує на верифікацію' },
  [EMENInvoiceState.UPDATED]: { status: 'Оновлена', statusComment: 'Очікує на верифікацію' },
  [EMENInvoiceState.VERIFIED]: { status: 'Верифіковано', statusComment: 'Готово до відправки' },
  [EMENInvoiceState.NOT_VERIFIED]: { status: 'Не верифіковано', statusComment: '' },
}

export const DEFAULT_SUBSTATE = 'Інше';

export const CONTACT_COMMENT = `Потребує уточнення. Зв'яжіться з нами за телефоном 0443500544, 0678300544`;


export const ZEBRA_ALLOWED_PRINT_STATES = [
  EMENInvoiceState.VERIFIED,
];
